import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, ShoppingBag, Star, Gift } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { api, inr } from "@/lib/api";
import { Img } from "@/components/common";

export default function ProductCard({ p, compact }) {
  const { addToCart, setShareProduct, requireAuth, pct, refOn } = useApp();
  const [wish, setWish] = useState(false);
  const nav = useNavigate();
  const off = p.mrp > p.price ? Math.round((1 - p.price / p.mrp) * 100) : 0;
  const reward = ((p.price * pct) / 100).toFixed(2);
  const toggleWish = requireAuth(async () => {
    const r = await api.post(`/wishlist/${p.id}`);
    setWish(r.data.wishlisted);
    toast(r.data.wishlisted ? "Saved to wishlist 💛" : "Removed from wishlist");
  });
  return (
    <div data-testid={`product-card-${p.slug}`} className="group card relative flex flex-col overflow-hidden transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(107,29,47,0.12)]">
      <Link to={`/product/${p.slug}`} className="img-zoom relative block">
        <Img src={p.image} alt={p.name} ratio="aspect-square" />
        {off > 0 && <span className="absolute left-3 top-3 rounded-full bg-[#6B1D2F] px-2 py-0.5 text-[10px] font-bold text-white">{off}% OFF</span>}
        {p.stock === 0 && <span className="absolute inset-x-0 bottom-0 bg-black/60 py-1 text-center text-xs font-semibold text-white">Out of stock</span>}
      </Link>
      <button onClick={toggleWish} data-testid={`product-wishlist-${p.slug}`} aria-label="Wishlist"
        className="absolute right-3 top-3 rounded-full bg-white/90 p-2 shadow-sm"><Heart className={`h-4 w-4 ${wish ? "fill-[#E11D48] text-[#E11D48]" : "text-[#57534E]"}`} /></button>
      <div className="flex flex-1 flex-col p-3 sm:p-4">
        <Link to={`/product/${p.slug}`} className="line-clamp-2 text-sm font-semibold leading-snug hover:text-[#6B1D2F]">{p.name}</Link>
        <div className="mt-1 flex items-center gap-1 text-xs text-[#78716C]"><Star className="h-3.5 w-3.5 fill-[#D4AF37] text-[#D4AF37]" />{p.rating} <span>({p.reviews_count})</span></div>
        <div className="mt-1.5 flex items-baseline gap-2">
          <span className="text-base font-bold text-[#292524]">{inr(p.price)}</span>
          {off > 0 && <s className="text-xs text-[#A8A29E]">{inr(p.mrp)}</s>}
        </div>
        {refOn && p.referral_eligible && <p className="mt-1 text-[11px] font-medium text-[#9A7B1C]">Earn {inr(reward)} referral reward</p>}
        {!compact && (
          <div className="mt-auto grid grid-cols-2 gap-2 pt-3">
            <button disabled={p.stock === 0} onClick={() => addToCart(p)} data-testid={`product-add-to-cart-${p.slug}`} className="btn-ghost !px-2 !py-2 text-xs"><ShoppingBag className="h-3.5 w-3.5" />Add</button>
            {refOn && p.referral_eligible ? (
              <button onClick={requireAuth(() => setShareProduct(p))} data-testid={`product-refer-${p.slug}`} className="btn !px-2 !py-2 bg-[#FEF3C7] text-xs text-[#9A3412] hover:bg-[#FDE68A]"><Gift className="h-3.5 w-3.5" />Refer {pct}%</button>
            ) : <button onClick={() => nav(`/product/${p.slug}`)} className="btn-ghost !px-2 !py-2 text-xs">View</button>}
          </div>
        )}
      </div>
    </div>
  );
}
